import React from 'react'
import CaseStudyHeader from '../../components/Header/CSHeader/CaseStudyHeader.jsx'

import menucover from './assets/menucover.webp'
import insight from './assets/insight.webp'
import telegram from './assets/telegram.webp'
import observation from './assets/observation.webp'
import obsresult1 from './assets/obsresult1.webp'
import userjourney from './assets/userjourney.webp'

import earlyflaw1 from './assets/earlyflaw1.webp'
import earlyflaw2 from './assets/earlyflaw2.webp'
import earlyflaw3 from './assets/earlyflaw3.webp'
import earlyflaw4 from './assets/earlyflaw4.webp'



function Menu() {


    return (
        <section>

            <CaseStudyHeader Pagetitle={'Paperless food menu to fight the pandemic'} />

            <img
                className='cover-img'
                src={menucover}
                alt=""
                loading="lazy"
            />


            <div className='cs-content'>

                <div className="top-l"></div>

                <h2>Designing digital food menu to fight the pandemic.</h2>

            </div>


            <div className='cs-content'>

                <p className="md">
                    Digital menu is a web app designed to replace the conventional paper menu in a restaurants during the pandemic as they apart from being dirty could also be affected by the corona virus.
                </p>


            </div>

            <div className='cs-content'>

                <h4>The truth about paper menus </h4>


                <p className='md'>
                    Menus are among the most unsanitary surfaces in a restaurant. The bacteria count on menus can be as high as 185,000 per square centimeter – far more than found on a toilet seat, according to a study published by Cleaning & Maintenance Management in 2014.
                </p>

                <p>
                    Upwards of 95% of people fail to properly wash their hands after restroom use, according to statistics. That makes handling a restaurant menu before eating a health gamble. After COVID-19 broke out menus apart from being dirty could now have the covid virus. This is why digital menu was not a want but a need.
                </p>

            </div>

            <div className='cs-content'>

                <h4>My Role</h4>

                <p>
                    As the sole designer for this project, my task was to design a web app to replace the paper menus, aiming to reduce the contact between restaurant staff and customers. i was involved in this project from 0→1 . To design this app successfully, I had to be involved in all phases from research to design, iteration and testing.
                </p>

            </div>

            <div className='cs-content'>

                <h4>Achievements</h4>

                <p>
                    Digital menu stands as one of the most impactful projects ive designed.
                </p>

                <ul>
                    <li>Helped provide a safer dining experience to hundreds of customers and potentially shielded them from the corona virus by minimising direct contact between customers and staff.</li>

                    <li>Adoption of the digital menu concept by 14 other restaurants, showcasing its success, scalability and adaptability.</li>

                    <li>After digital menu was implemented and advertised, the restaurant saw a unusual influx of customers : increase of 36.2% per day than daily avg as per the restaurant billing data.</li>

                    <li>Positioned the project as a benchmark solution within nearby restaurants, influencing how eateries approached their menus and customer interactions.</li>
                </ul>

            </div>


            <div className='cs-content'>

                <h4>Primary Goal </h4>

                <p>My primary objective was to comprehend the fundamental challenges at a restaurant posed by the pandemic and devise a ‘digital menu’ solution that minimised direct interactions of customers with the restaurant staff.</p>

            </div>

            <div className='cs-content'>

                <h4>Finding out why restaurant saw a dip in customers in the early phase of covid</h4>

                <p>
                    This app wasn't aimed at bring people out from their safe homes to the unsafe restaurants, but rather to keep safe the customers who were coming out to eat anyway. The reason the restaurant experienced a dip in number of customers was clearly because of the fear of the pandemic, but i wanted to learn what they feared - was it coming in contact with the staff? or the indoor experience? and how many felt this way.
                    <br /><br />
                    To understand this i conducted interviews with a few regular customer that agreed to volunteer, i also had detailed discussions with the restaurant staff to understand their issues and how we could minimize the contact between restaurant staff and customers.
                </p>

                <img src={telegram} alt="" />

                <p>
                    Apart from conducting interviews, I also posted polls in Telegram groups to understand people's main concerns. My goal was to gather statistics on the top five fears people have about coming to the restaurant during this time.
                </p>

                <img src={insight} alt="" />

                <p className="md">The interviews made it clear that customers feared coming in contact with the staff and touching surfaces the most. This lit a light bulb that there was indeed a gap in the market that was not filled. Restaurant with minimized contact with staff and properly sanitized would see a influx of customers, This later proved to be true. - See Achievements at end of case study</p>

            </div>


            <div className='cs-content'>

                <h4>How do you select food from a menu ?</h4>

                <p>
                    At the core the app was a menu and people had to order food with it. To understand how people interacted with a menu and ordered food from it i observed a few volunteered customers select the food they wanted, additionally i also encouraged them to vocalize their thoughts. the result from this would help me in improving app navigation and give me a rough idea on how to structure the app.

                    <br /><br />

                    What i found out : the result was interesting, customers didn't look at the menus from page to page to find what they wanted, they skipped pages to reached the category directly and then analysed the food inside that specific category resulting.this helped me understand that category and cuisines should be the first thing to show to not annoy the customers.
                </p>

                <img src={observation} alt="" />
                <img src={obsresult1} alt="" />



                <p>
                    After i understood this concept, i implemented in design by giving the categories first on the home page under search, this would help user jump to exactly where they need without searching a list of all food.
                </p>

            </div>


            <div className='cs-content'>

                <h6>High level User Journey</h6>

                <h4>Getting the idea out of my brains</h4>

                <p>
                    After several rounds of iterations i came up with a userflow. this was the most logical but was yet to be tested. this would help me draw a few wireframes which would help me think clearer.

                </p>

                <img src={userjourney} alt="" />

            </div>



            <div className='cs-content'>

                <h6>Wire framing & Iterations.</h6>

                <h4>Sketching, scribbling and wireframing with multiple iterations.</h4>

                <p>
                    I initially drew a few sketches of the app. then started to improve each flows by iteration, i experimented each flows in multiple ways to acheive the same result to test which would have the best user experience. After several rounds of iterations i came up with a wireframe.
                </p>

                <img src="https://placehold.co/1000" alt="" />

            </div>



            <div className='cs-content'>

                <h6>High Fidelity design</h6>

                <h4>Creating Pixel Perfect Designs</h4>

                <p>
                    I converted the wireframes to high fidelity design, I choose colors based on color psychology and that would match a restaurant related application. 8pt grid system and 3 column grid system were used.
                </p>

                <img src={menucover} alt="" />

            </div>

            <div className='cs-content'>

                <h6>Fixing Issues</h6>

                <h4>Fixing User Experience Issues</h4>

                <p>
                    I self tested the design to find some early design flaws, this iteration involed fixing these issues. some of the major flaws are mentioned below.
                </p>

                <img src={earlyflaw1} alt="" />

                <p>
                    Missed the button to ping the waiter, this button would help ping the waiter asking for help or if the user gets stuck. The waiter would be notifed on his side of the application
                </p>

                <img src={earlyflaw2} alt="" />

                <p>
                    After the user added a item to order and wants to confirm and place the order, the user must go to 'orders page' - currently he had to go through multiple clicks to reach there. I realized with showing a floating button when the user adds first product to order the clicks was reduced from multiple to just one click
                </p>

                <img src={earlyflaw3} alt="" />

                <p>
                    Added missing quantity button on the order page
                </p>

                <img src={earlyflaw4} alt="" />

                <p>

                    After a user opens a category, switching to another category required going back, which disrupted the flow. To improve the experience, a way to switch categories was added at the end of every category page.
                </p>

            </div>


            <div className='cs-content'>

                <h6>Achievements</h6>

                <h4>Digital menu stands as one of the most impactful projects ive designed.</h4>

                <ul>

                    <li>
                        Helped provide a safer dining experience to hundreds of customers and potentially shielded them from the corona virus by minimising direct contact between customers and staff.
                        Adoption of the digital menu concept by 14 other restaurants, showcasing its success, scalability and adaptability.
                    </li>

                    <li>
                        After digital menu was implemented and advertised, the restaurant saw a unusual influx of customers : increase of 36.2% per day than daily avg as per the restaurant billing data.
                    </li>

                    <li>
                        Positioned the project as a benchmark solution within nearby restaurants, influencing how eateries approached their menus and customer interactions.
                    </li>

                </ul>

            </div>








        </section>
    )
}

export default Menu